<template>
  <GermanBiModal
    v-if="isFeatureEnabled"
    ref="modal"
  />
</template>

<script setup lang="ts">
import { ref, computed, watch, onMounted, nextTick } from 'vue';
import GermanBiModal from './german-bi-modal.vue';
import { useGermanBi } from '../composables/use-german-bi';
import { FeatureFlag, isEnabled } from '@monolith/legacy/services/features';

const modal = ref<InstanceType<typeof GermanBiModal> | null>(null);
const { shouldShowModal } = useGermanBi();
const hasOpened = ref(false);
const isFeatureEnabled = computed(() => isEnabled(FeatureFlag.GermanBusinessIdentifierModal));

const tryOpenModal = async () => {
  if (isFeatureEnabled.value && shouldShowModal.value && !hasOpened.value) {
    await nextTick();
    if (modal.value) {
      modal.value.open();
      hasOpened.value = true;
    }
  }
};

// Try on mount (when retailer might already be loaded)
onMounted(() => {
  tryOpenModal();
});

// Watch for async retailer load
watch(shouldShowModal, (shouldShow) => {
  if (shouldShow) {
    tryOpenModal();
  }
});
</script>
